module.exports = __webpack_public_path__ + "static/media/vinglabs_proteus_1080p.60f4c749.mp4";